import anime from 'animejs'
import {
  createAnimation
} from '../utils/createAnimation'
import {
  characterWalk
} from '../utils/characterWalk'
import {
  createRotateAnimation
} from '../utils/createRotateAnimation'

// Hailey animations
const haileyAnimations = () => {
  return {
    slideIn(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#hailey",
            right: ['-35%', '5%'],
            duration: 2000,
            easing: 'linear',
            begin: options.begin,
            complete: options.complete
          })

      }, options, this)()
    },
    walkInPlace(options) {
      return createAnimation((tl, options) => {
        options.duration = options.duration || 8000
        options.flipped = options.flipped || false
        options.right = options.right || ['5%', '32%']

        tl
          .add({
            targets: '#hailey',
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            }, // flip hailey conditionally
            right: {
              value: options.right,
              duration: 10000 // options.duration / 3
            }, // gradually move closer to center of scene // todo: maintain 32% place
            translateY: characterWalk(options.duration),
            easing: 'linear',
            duration: options.duration,
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    raiseLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#hailey_left_arm_hand",
            rotate: "100deg",
            duration: 350,
            easing: "linear",
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    lowerLeftArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#hailey_left_arm_hand",
            rotate: "0deg",
            duration: 350,
            easing: "linear",
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    },
    raiseRightArm(options) {
      return createAnimation((tl, options) => {

        tl

          .add({
            targets: "#hailey_right_arm",
            rotate: "15deg",
            duration: 350,
            easing: "linear",
            begin: options.begin
          })

          .add({
            targets: "#hailey_right_arm_hand",
            rotate: "90deg",
            duration: 350,
            easing: "linear",
            complete: options.complete
          })

      }, options, this)()
    },
    wave(options) { // chain raise right arm and lower right arm methods
      return createAnimation((tl, options) => {
        this.raiseRightArm({
          complete: () => {
            createAnimation((tl, waveOptions) => {
              tl
                .add({
                  targets: "#hailey_right_arm_hand",
                  rotate: "100deg",
                  duration: 300,
                  easing: "linear",
                })
                .add({
                  targets: "#hailey_right_arm_hand",
                  rotate: "90deg",
                  duration: 300,
                  easing: "linear"
                })
                .add({
                  targets: "#hailey_right_arm_hand",
                  rotate: "100deg",
                  duration: 300,
                  easing: "linear"
                })
                .add({
                  targets: "#hailey_right_arm_hand",
                  rotate: "90deg",
                  duration: 300,
                  easing: "linear",
                  complete: waveOptions.complete
                })
            }, { // waveOptions
              delay: 300,
              complete: () => {
                this.lowerRightArm({
                  delay: 350,
                  complete: options.complete // parent options
                })
              }
            }, this)()
          }
        })
      }, options, this)()
    },
    lowerRightArm(options) {
      return createAnimation((tl, options) => {
        tl
          .add({
            targets: "#hailey_right_arm_hand",
            rotate: "0deg",
            duration: 350,
            easing: "linear",
            begin: options.begin,
          })
          .add({
            targets: "#hailey_right_arm",
            rotate: "0deg",
            duration: 350,
            easing: "linear",
            complete: options.complete
          })
      }, options, this)()
    },
    rotate(options) {
      return createAnimation(createRotateAnimation('#hailey'), options, this)()
    },
    headRotate(options) {
      return createAnimation((tl, options) => {
        options.flipped = options.flipped || false
        tl
          .add({
            targets: "#hailey_head",
            scaleX: {
              value: options.flipped ? -1 : 1,
              duration: 1
            },
            translateX: {
              value: options.flipped ? 1 : 0,
              duration: 1
            },
            translateY: {
              value: options.flipped ? 1 : 0,
              duration: 1
            },
            begin: options.begin,
            complete: options.complete
          })
      }, options, this)()
    }
  }
}

export {
  haileyAnimations
}



// WEBPACK FOOTER //
// ./src/assets/js/characters/haileyAnimations.js